import { ComponentFormValues, KomponentenTypEnum } from '../../components/ParamComponents';
import { ColumnSortInfo } from '../../components/DataTable/PCDataTable';
import { KomponenteFilter } from '../../generated/types';
import { DocumentNode } from 'graphql';


export interface ComponentQueryResult {
  query: any;
  sort: any;
}
export abstract class ComponentQuery {


  getGeneralFilter = (role: string, filter: ComponentFormValues): KomponenteFilter => {
    var queryFilter: KomponenteFilter = {};

    if(filter?.code) queryFilter.codeContains = filter.code.trim();
    if(filter?.name) queryFilter.nameContains = filter.name.trim();

    //@ts-ignore
    if(filter?.status && filter.status.length > 0) {
      //@ts-ignore
      queryFilter.status = filter.status.map(e => e.value);
    }

    if(filter.kind === KomponentenTypEnum.Stoff || filter.kind === KomponentenTypEnum.Nichtstofflich 
      || filter.kind === KomponentenTypEnum.Probenvorbehandlung || filter.kind === KomponentenTypEnum.Methode
      || filter.kind === KomponentenTypEnum.SonstigesKriterium || filter.kind === KomponentenTypEnum.Matrix) {
    
      if(filter.annotations) {
        queryFilter.anmerkungContains = filter?.annotations.trim();
      }
    }

    return queryFilter;
  }

  getGeneralDuplicateFilter = (codeList: string[]): KomponenteFilter => {
    const queryFilter: KomponenteFilter = {};

    queryFilter.code = codeList.map( code => code);
    return queryFilter;
  }

  abstract getComponentList(sortBy?: ColumnSortInfo[]): ComponentQueryResult;

  /**
   * 
   */
  abstract getComponent(): DocumentNode;

}
